import { GamesTypes } from '@app/domain/enums/game';
import type { GameTeam } from '@app/domain/interfaces/game/game-team.interface';

export type CountdownBrand = 'bingoals' | 'goalrush' | 'match15';

export const ASSETS_PATH = '/assets/components/countdown-bar/';

export const GAME_LIVE_IMAGE = `${ASSETS_PATH}game-live.png`;

export const HIDE_BUTTON_IMAGE = `${ASSETS_PATH}hide-button.png`;

const SECONDS_PER_MINUTE = 60;
const PAD_LENGTH = 2;
const PAIR_SIZE = 2;
const PAIRS_END = 4;
const ABBR_MAX = 3;

const HEADER_LEFT_IMAGE = new Map<GamesTypes, string>([
  [GamesTypes.BINGOALS, `${ASSETS_PATH}live.png`],
  [GamesTypes.CRICKET, `${ASSETS_PATH}live.png`],
  [GamesTypes.DARTS, `${ASSETS_PATH}live.png`],
  [GamesTypes.FOOTBALL, `${ASSETS_PATH}live.png`],
  [GamesTypes.GOAL_RUSH, `${ASSETS_PATH}live.png`],
  [GamesTypes.NOW, `${ASSETS_PATH}canned_now.png`],
  [GamesTypes.QUICK, `${ASSETS_PATH}canned_quick.png`],
  [GamesTypes.SOCCER, `${ASSETS_PATH}live.png`],
  [GamesTypes.TENNIS, `${ASSETS_PATH}live.png`],
]);

export function brand(type: GamesTypes): CountdownBrand {
  if (type === GamesTypes.BINGOALS || type === GamesTypes.NOW) {
    return 'bingoals';
  }

  if (type === GamesTypes.GOAL_RUSH) {
    return 'goalrush';
  }

  return 'match15';
}

export function brandImage(type: GamesTypes): string {
  const name = brand(type);

  if (name === 'bingoals') {
    return `${ASSETS_PATH}bingoals-logo.png`;
  }

  if (name === 'goalrush') {
    return `${ASSETS_PATH}gola_rush.png`;
  }

  return `${ASSETS_PATH}match-15.png`;
}

export function formatTime(seconds: number): string {
  const minutes = Math.floor(seconds / SECONDS_PER_MINUTE);
  const remaining = seconds % SECONDS_PER_MINUTE;

  return `${pad(minutes)}:${pad(remaining)}`;
}

export function headerLeftImage(type: GamesTypes): null | string {
  return HEADER_LEFT_IMAGE.get(type) ?? null;
}

export function liveText(type: GamesTypes): string {
  return brand(type) === 'goalrush' ? 'LIVE' : 'LIVE!';
}

export function teamAbbreviation(team: GameTeam): string {
  if (team.abbreviation) {
    return team.abbreviation;
  }

  return team.name
    .split(/\s+/)
    .filter(Boolean)
    .map(part => part[0])
    .join('')
    .slice(0, ABBR_MAX)
    .toUpperCase();
}

export function timerDigitPairs(seconds: number): string[][] {
  const digits = formatTime(seconds).replace(':', '').split('');

  return [digits.slice(0, PAIR_SIZE), digits.slice(PAIR_SIZE, PAIRS_END)];
}

export function usesTeamLogos(type: GamesTypes): boolean {
  return type === GamesTypes.BINGOALS || type === GamesTypes.NOW || type === GamesTypes.GOAL_RUSH;
}

function pad(value: number): string {
  return String(value).padStart(PAD_LENGTH, '0');
}
